import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { SERVICES } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import { ArrowUpRight } from "lucide-react";
import CTASection from "../components/CTASection";

export default function Services() {
  const { services = SERVICES } = useContent();
  return (
    <>
      <PageHero
        kicker="HİZMETLERİMİZ"
        title="İşletmeniz için teşvik edici çözümler."
        subtitle="Yatırım teşvik belgesinden Ar-Ge destek programlarına, turizm belgelerinden ihracat desteklerine kadar geniş bir hizmet yelpazesi sunuyoruz."
      />
      <section className="py-20 lg:py-28 bg-[#0a0a0a]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s, idx) => (
              <Link
                key={s.slug}
                to={`/hizmet/${s.slug}`}
                className="group relative border border-[#B87333]/20 bg-[#0d0b09] p-10 overflow-hidden hover:border-[#B87333] transition-colors duration-500"
              >
                <div className="text-[11px] tracking-[0.3em] text-[#B87333]/50 group-hover:text-[#B87333] mb-6">
                  {String(idx + 1).padStart(2, "0")}
                </div>
                <h3 className="font-serif-display text-[#f5ede1] text-2xl leading-snug mb-4">
                  {s.title}
                </h3>
                <p className="text-[#a89a85] text-sm leading-relaxed mb-8">{s.short}</p>
                <div className="flex items-center justify-between pt-6 border-t border-[#B87333]/15">
                  <span className="text-[11px] tracking-[0.3em] text-[#f5ede1] group-hover:text-[#B87333] transition-colors">DETAY</span>
                  <ArrowUpRight className="w-5 h-5 text-[#B87333] transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
